import { render, staticRenderFns } from "./calcdictList.vue?vue&type=template&id=2a173658&scoped=true&"
import script from "./calcdictList.vue?vue&type=script&lang=js&"
export * from "./calcdictList.vue?vue&type=script&lang=js&"
import style0 from "./calcdictList.vue?vue&type=style&index=0&id=2a173658&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a173658",
  null
  
)

export default component.exports